/* ============================================================
   HIRA MODA – Gratis-Hijab Geschenkbox (Logik)
   - Haengt sich per Event-Delegation an (ueberlebt Drawer-Neuaufbau)
   - Nutzt die Section-Rendering-API wie der bestehende Drawer
   - Doppelklick-/Mehrfach-Schutz via globalem Lock
   - Max. 1 Geschenk: bestehende Geschenk-Zeile wird vor dem Hinzufuegen ersetzt
   - Auto-Entfernung, wenn kein berechtigtes Produkt mehr im Korb liegt
   ============================================================ */
(function () {
  if (window.__hmGiftHijab) return;
  window.__hmGiftHijab = true;

  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) ? Shopify.routes.root : '/';
  var SECTIONS = 'cart-drawer,cart-icon-bubble';
  var busy = false;
  var cleanupTried = false;

  function post(url, data) {
    data.sections = SECTIONS;
    data.sections_url = window.location.pathname;
    return fetch(ROOT + url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(data)
    }).then(function (r) { return r.json(); });
  }
  function getCart() {
    return fetch(ROOT + 'cart.js', { headers: { 'Accept': 'application/json' } }).then(function (r) { return r.json(); });
  }

  function applySections(sections) {
    if (sections && sections['cart-drawer']) {
      var doc = new DOMParser().parseFromString(sections['cart-drawer'], 'text/html');
      var fresh = doc.querySelector('#CartDrawer');
      var cur = document.querySelector('#CartDrawer');
      if (fresh && cur) cur.innerHTML = fresh.innerHTML;
    }
    if (sections && sections['cart-icon-bubble']) {
      var bub = document.querySelector('#cart-icon-bubble');
      var d2 = new DOMParser().parseFromString(sections['cart-icon-bubble'], 'text/html');
      var fb = d2.querySelector('.shopify-section') || d2.body;
      if (bub && fb) bub.innerHTML = fb.innerHTML;
    }
    var cd = document.querySelector('cart-drawer');
    if (cd && document.querySelector('#CartDrawer .cart-item')) cd.classList.remove('is-empty');
  }

  // Im Drawer: nur Warenkorb-Teil neu rendern. Auf der Warenkorb-Seite: leicht neu laden.
  function refresh(res) {
    busy = false;
    if (document.querySelector('#CartDrawer')) {
      applySections(res && res.sections);
      cleanupTried = false;
      scheduleHide();
    } else {
      window.location.reload();
    }
  }

  function findGift(cart) {
    var items = (cart && cart.items) || [];
    for (var i = 0; i < items.length; i++) {
      var p = items[i].properties;
      if (p && p._gift === 'true') return items[i];
    }
    return null;
  }

  function setBusy(on) {
    busy = on;
    var box = document.querySelector('[data-gh-box]');
    if (box) box.classList.toggle('gh-box--busy', on);
  }

  function showError() {
    var m = document.querySelector('[data-gh-msg]');
    if (m) m.textContent = 'Etwas hat nicht geklappt. Bitte versuch es noch einmal.';
    setBusy(false);
  }

  function setGift(variantId) {
    if (busy || !variantId) return;
    setBusy(true);
    getCart().then(function (cart) {
      var existing = findGift(cart);
      if (existing && String(existing.variant_id) === String(variantId)) {
        setBusy(false);
        return null;
      }
      var chain = Promise.resolve();
      if (existing) {
        chain = post('cart/change.js', { id: existing.key, quantity: 0 });
      }
      return chain.then(function () {
        return post('cart/add.js', {
          items: [{ id: parseInt(variantId, 10), quantity: 1, properties: { _gift: 'true' } }]
        });
      }).then(function (res) { refresh(res); });
    }).catch(showError);
  }

  function removeGift() {
    if (busy) return;
    var box = document.querySelector('[data-gh-box]');
    var key = box && box.getAttribute('data-gh-giftkey');
    if (!key) return;
    setBusy(true);
    post('cart/change.js', { id: key, quantity: 0 })
      .then(function (res) { refresh(res); })
      .catch(showError);
  }

  // Die echte Geschenk-Zeile aus der normalen Produktliste ausblenden,
  // damit der Hijab nur EINMAL (in der gruenen Box) erscheint.
  var ghHideTimer = null;
  function scheduleHide() {
    if (ghHideTimer) return;
    ghHideTimer = setTimeout(function () { ghHideTimer = null; hideGiftLine(); }, 150);
  }
  function hideGiftLine() {
    var box = document.querySelector('[data-gh-box]');
    if (!box || box.getAttribute('data-gh-hasgift') !== '1') return;
    getCart().then(function (cart) {
      var items = (cart && cart.items) || [];
      var idx = -1;
      for (var i = 0; i < items.length; i++) {
        var p = items[i].properties;
        if (p && p._gift === 'true') { idx = i; break; }
      }
      if (idx < 0) return;
      var rows = document.querySelectorAll('#CartDrawer .cart-item');
      var row = rows[idx];
      if (row && row.style.display !== 'none') row.style.display = 'none';
    }).catch(function () {});
  }

  // Geschenk automatisch entfernen, wenn kein berechtigtes Produkt mehr vorhanden ist.
  function autoCleanup() {
    var box = document.querySelector('[data-gh-box]');
    if (!box || busy || cleanupTried) return;
    if (box.getAttribute('data-gh-hasgift') === '1' && box.getAttribute('data-gh-eligible') === '0') {
      cleanupTried = true;
      removeGift();
    }
  }

  function selectSwatch(sw) {
    var box = sw.closest('[data-gh-box]');
    if (!box) return;
    var prev = box.querySelectorAll('.gh-sw.is-sel');
    for (var i = 0; i < prev.length; i++) prev[i].classList.remove('is-sel');
    sw.classList.add('is-sel');
    var add = box.querySelector('[data-gh-add]');
    var label = sw.getAttribute('data-gh-label') || '';
    if (add) {
      add.setAttribute('data-gh-variant', sw.getAttribute('data-gh-variant'));
      add.disabled = false;
      var txt = add.querySelector('.gh-add__txt');
      if (txt) txt.textContent = 'Gratis-Hijab hinzufügen';
    }
    var pl = box.querySelector('[data-gh-picklabel]');
    if (pl) pl.textContent = label ? ('Ausgewählt: ' + label) : '';
  }

  function expandSwatches(btn) {
    var box = btn.closest('[data-gh-box]');
    if (!box) return;
    var extra = box.querySelectorAll('.gh-sw--extra[hidden]');
    for (var i = 0; i < extra.length; i++) extra[i].hidden = false;
    btn.parentNode && btn.parentNode.removeChild(btn);
  }

  document.addEventListener('click', function (e) {
    if (!e.target.closest) return;
    var more = e.target.closest('[data-gh-more]');
    if (more) { e.preventDefault(); expandSwatches(more); return; }
    var sw = e.target.closest('.gh-sw[data-gh-variant]');
    if (sw) { e.preventDefault(); selectSwatch(sw); return; }
    var add = e.target.closest('[data-gh-add]');
    if (add) { e.preventDefault(); if (!add.disabled) setGift(add.getAttribute('data-gh-variant')); return; }
    var chg = e.target.closest('[data-gh-change]');
    if (chg) {
      e.preventDefault();
      var box = chg.closest('[data-gh-box]');
      var picker = box && box.querySelector('[data-gh-picker]');
      if (picker) picker.classList.remove('gh-picker--hidden');
      return;
    }
    var rm = e.target.closest('[data-gh-remove]');
    if (rm) { e.preventDefault(); removeGift(); return; }
  });

  function boot() {
    autoCleanup();
    scheduleHide();
    var cd = document.querySelector('cart-drawer');
    if (cd && window.MutationObserver) {
      new MutationObserver(function () { autoCleanup(); scheduleHide(); })
        .observe(cd, { childList: true, subtree: true });
    }
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
